export default __webpack_public_path__ + "img/web-hour-top-item-985b4ad8.png";